import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react';
import clsx from 'clsx';

type OverlayProps = {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  className?: string;
};

/**
 * Knox Overlay — replaces folds Overlay + OverlayBackdrop + OverlayCenter + focus-trap-react.
 *
 * Built on @headlessui/react Dialog which provides:
 * - Focus trapping (no focus-trap-react dependency)
 * - Escape key to close
 * - Click-outside to close (via backdrop)
 * - Portal rendering
 * - Proper aria attributes
 */
export function Overlay({ open, onClose, children, className }: OverlayProps) {
  return (
    <Dialog open={open} onClose={onClose} className={clsx('relative z-50', className)}>
      {/* Semi-transparent backdrop with fade transition */}
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-black/60 transition-opacity duration-200 data-[closed]:opacity-0"
      />

      {/* Centered panel wrapper */}
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel
          transition
          className="transition-all duration-200 data-[closed]:opacity-0 data-[closed]:scale-95"
        >
          {children}
        </DialogPanel>
      </div>
    </Dialog>
  );
}
